import {  post, } from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";



export const getCreditOptionList = async (data:any): Promise<DataResponse<any>> => {
    const url = `${endpoints.getCreditOptionList}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data,config);
  };
  
  